module.exports = __webpack_public_path__ + "static/media/event.497726dc.png";